export default __webpack_public_path__ + "788772ffc124645a2cc6fff83210e77b.png";